"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// npm-package/index.ts
var npm_package_exports = {};
__export(npm_package_exports, {
  AppFeatures: () => AppFeatures,
  createPostMessageHandlers: () => createPostMessageHandlers,
  devAppConfig: () => devAppConfig,
  devConfig: () => devConfig,
  devMainWebviewTitlesRecord: () => devMainWebviewTitlesRecord,
  devWebviewSheetTitlesRecord: () => devWebviewSheetTitlesRecord,
  getDevMainWebviewTitle: () => getDevMainWebviewTitle,
  getDevWebviewSheetTitle: () => getDevWebviewSheetTitle,
  getProdMainWebviewTitle: () => getProdMainWebviewTitle,
  getProdWebviewSheetTitle: () => getProdWebviewSheetTitle,
  prodAppConfig: () => prodAppConfig,
  prodConfig: () => prodConfig,
  prodMainWebviewTitlesRecord: () => prodMainWebviewTitlesRecord,
  prodWebviewSheetTitlesRecord: () => prodWebviewSheetTitlesRecord,
  schemas: () => schemas,
  sendPostMessage: () => sendPostMessage,
  zDynamicConfig: () => zDynamicConfig,
  zMainWebviewTitleKeys: () => zMainWebviewTitleKeys,
  zMainWebviewTitles: () => zMainWebviewTitles,
  zSaleConfig: () => zSaleConfig,
  zWebviewSheetTitleKeys: () => zWebviewSheetTitleKeys,
  zWebviewSheetTitles: () => zWebviewSheetTitles
});
module.exports = __toCommonJS(npm_package_exports);

// src/env/dev/app-config.json
var app_config_default = {
  aprValue: "11.4",
  ios: {
    requiredAppVersion: "1.0.0",
    recommendedAppVersion: "1.0.0",
    isSuspended: false
  },
  android: {
    requiredAppVersion: "1.0.0",
    recommendedAppVersion: "1.0.0",
    isSuspended: false
  },
  mainWebviewLoggedInURLs: [
    "/checkout/bank-payment/",
    "/checkout/car-care/",
    "/checkout/card-details/",
    "/checkout/confirmation/",
    "/checkout/delivery/",
    "/checkout/editable-customer-info/",
    "/checkout/finance-application-approved/",
    "/checkout/finance-application-decision/",
    "/checkout/finance-application-offer/",
    "/checkout/finance-application-outgoings/",
    "/checkout/finance-application-review/",
    "/checkout/finance-bank-details/",
    "/checkout/finance-cant-apply/",
    "/checkout/finance-current-address/",
    "/checkout/finance-employment-history/",
    "/checkout/finance-offer-amends/",
    "/checkout/finance-personal-details/",
    "/checkout/finance/",
    "/checkout/id-verification/",
    "/checkout/part-exchange",
    "/checkout/payment/",
    "/checkout/personal-details/",
    "/checkout/settlement-letter-upload/",
    "/checkout/verify-email/"
  ],
  mainWebviewLoggedOutURLs: [
    "/car-finance/check-eligibility",
    "/checkout/your-order/",
    "/compare-cars",
    "/find-vehicle",
    "/help-me-choose/body-types",
    "/help-me-choose/car-makes",
    "/help-me-choose/most-important",
    "/help-me-choose/passengers",
    "/help-me-choose/price-range",
    "/help-me-choose/recommendations",
    "/offers",
    "/part-exchange/calculator",
    "/used-cars/",
    "/used-cars"
  ],
  webviewSheetURLs: [
    "/car-collections",
    "/car-finance",
    "/cars-near-me/collection-location",
    "/cinch-care",
    "/cinch-care/servicing",
    "/cinch-care/warranty-information",
    "/cinch-shield",
    "/cinchshield-lifeshine-guarantee",
    "/delivery",
    "/finance/Cinch_IDD",
    "/finance/hp-explanation",
    "/finance/pcp-explanation",
    "/part-exchange",
    "/policies/terms-and-conditions",
    "/post/ulez-explained-by-cinch",
    "/returns",
    "/sign-up",
    "/terms-and-conditions",
    "/which-car-should-i-buy"
  ],
  inAppBrowserHosts: [
    "trial.bonafidee.com",
    "secure.bonafidee.com",
    "web.evolutionfunding.com",
    "www.evolutionfunding.com",
    "evolutionfunding.com",
    "sandbox.evolutionfunding.com",
    "public.evolutionfunding.com",
    "www.blackhorse.co.uk",
    "www.google.com",
    "google.com",
    "bonafidee.com",
    "uk.trustpilot.com",
    "www.gov.uk",
    "gov.uk",
    "assets-dev.cinch.co.uk",
    "assets-production.cinch.co.uk",
    "www.ramplimited.co.uk",
    "cinch.tempcover.com",
    "www.cinch.tempcover.com",
    "www.experian.co.uk",
    "www.transunion.co.uk",
    "equifax.co.uk",
    "www.equifax.co.uk"
  ],
  inAppBrowserPaths: [
    "/privacy",
    "/terms-of-use",
    "/policies/privacy",
    "/support",
    "/car-inspection",
    "/news/ulez-explained-by-cinch",
    "/car-care/cinch-shield",
    "/car-care/charging-electric-cars",
    "/car-care/electric-car-home-charger",
    "/policies/terms-and-conditions"
  ],
  outsideAppBrowserURLs: ["wa.me", "api.whatsapp.com"],
  webviewThirdPartyURLs: ["stripe.com", "pm-redirects.stripe.com", "tink.com"],
  nativeScreenURLs: [
    "/",
    "/my-profile",
    "/native-favourites",
    "/my-profile/favourites",
    "/native-home",
    "/native-my-profile",
    "/native-part-exchange"
  ],
  mainWebviewTitles: {
    Search: "Find a car",
    ProductPage: "Car details",
    OrderOverview: "Order overview",
    CreateAccount: "Create an account",
    PersonalDetails: "Enter your details",
    WantToPartExchange: "Add a part exchange",
    HowDoYouWantToPay: "Choose a payment option",
    FinanceCalculator: "Finance calculator",
    YourDetails: "Enter your details",
    AddAddressHistory: "Add address history",
    AddWorkHistory: "Add work history",
    CompareCars: "Compare cars",
    IncomingsAndOutgoings: "Incomings and outgoings",
    BankAccountMatch: "Bank account match",
    CheckAndSubmit: "Check and submit",
    UploadYourSettlementLetter: "Upload your settlement letter",
    AllFinancePagesPostOffer: "Finance application submitted",
    ChooseADelivery: "Pick a time slot",
    CarCare: "Add car care",
    ReviewAndPay: "Review and pay",
    OrderConfirmation: "Order confirmation",
    OrderBankPayment: "Bank Payment",
    CancelOrder: "Cancel your order",
    IDVerification: "ID Verification",
    EditCustomerInformation: "Edit customer information",
    CheckEligibility: "Finance eligibility checker",
    CarFinance: "Car finance",
    HelpMeChoose: "Help me choose",
    CanNotApply: "You can't apply for car finance"
  },
  webviewSheetTitles: {
    SIGNUP: "Sign up",
    TERMS: "Terms of use",
    COOKIE: "Cookie policy",
    PRIVACY: "Privacy policy",
    SUPPORT: "Support",
    PASSWORD: "Change password",
    DELIVERY: "Home delivery",
    PARTEXCHANGE: "Part exchange",
    RETURNS: "Returns",
    CARFINANCE: "Car finance",
    PCPEXPLANATION: "Personal contract purchase (PCP)",
    HPEXPLANATION: "Hire purchase (HP)",
    ULEZEXPLAINEDBYCINCH: "ULEZ explained by Cinch",
    WARRANTYINFORMATION: "Warranty inclusions and exclusions",
    SERVICING: "Routine servicing",
    TERMSOFUSE: "Terms of use",
    SUPPORTWEBVIEW: "Support",
    PRIVACYCOOKIE: "Privacy & cookie policy",
    CINCHIDD: "Initial Disclosure Document",
    CINCHSHIELD: "Cinch Shield",
    CINCHSHIELDLIFESHINE: "Lifeshine guarantee - Terms and conditions",
    CINCHCARE: "Cinch Care",
    TERMSCOND: "Car purchase terms and conditions",
    DEFAULT: "",
    Whatsapp: "Whatsapp",
    CHECKELIGIBILITY: "Check eligibility",
    CINCHCHARGE: "cinchCharge",
    CARINSPECTION: "Car inspection",
    COLLECTIONS: "Car collections",
    COLLECTIONLOCATION: "Collection location"
  },
  saleConfig: {
    TEXT: "Black Friday Buzz - ",
    SHOW_LINK: true,
    LINK_TEXT: "Shop EVs on offer \u2794",
    LINK_TAG: "Cars-on-offer",
    TEXT_COLOR: "pureWhite",
    BACKGROUND_COLOR: "pureBlack",
    TC_TEXT: "Ends 12pm 28/11. Discount varies by car. Charging valid only at cinchCharge network locations. ",
    TC_LINK_TEXT: "T&Cs apply.",
    TC_URL: "https://mobile.snc-dev.aws.cinch.co.uk/offers"
  }
};

// src/env/prod/app-config.json
var app_config_default2 = {
  aprValue: "11.4",
  ios: {
    requiredAppVersion: "1.0.0",
    recommendedAppVersion: "1.0.0",
    isSuspended: false
  },
  android: {
    requiredAppVersion: "1.0.0",
    recommendedAppVersion: "1.0.0",
    isSuspended: false
  },
  mainWebviewLoggedInURLs: [
    "/checkout/bank-payment/",
    "/checkout/car-care/",
    "/checkout/card-details/",
    "/checkout/confirmation/",
    "/checkout/delivery/",
    "/checkout/editable-customer-info/",
    "/checkout/finance-application-approved/",
    "/checkout/finance-application-decision/",
    "/checkout/finance-application-offer/",
    "/checkout/finance-application-outgoings/",
    "/checkout/finance-application-review/",
    "/checkout/finance-bank-details/",
    "/checkout/finance-cant-apply/",
    "/checkout/finance-current-address/",
    "/checkout/finance-employment-history/",
    "/checkout/finance-offer-amends/",
    "/checkout/finance-personal-details/",
    "/checkout/finance/",
    "/checkout/id-verification/",
    "/checkout/part-exchange",
    "/checkout/payment/",
    "/checkout/personal-details/",
    "/checkout/settlement-letter-upload/",
    "/checkout/verify-email/"
  ],
  mainWebviewLoggedOutURLs: [
    "/car-finance/check-eligibility",
    "/checkout/your-order/",
    "/compare-cars",
    "/find-vehicle",
    "/help-me-choose/body-types",
    "/help-me-choose/car-makes",
    "/help-me-choose/most-important",
    "/help-me-choose/passengers",
    "/help-me-choose/price-range",
    "/help-me-choose/recommendations",
    "/offers",
    "/part-exchange/calculator",
    "/used-cars/",
    "/used-cars"
  ],
  webviewSheetURLs: [
    "/car-collections",
    "/car-finance",
    "/cars-near-me/collection-location",
    "/cinch-care",
    "/cinch-care/servicing",
    "/cinch-care/warranty-information",
    "/cinch-shield",
    "/cinchshield-lifeshine-guarantee",
    "/delivery",
    "/finance/Cinch_IDD",
    "/finance/hp-explanation",
    "/finance/pcp-explanation",
    "/part-exchange",
    "/policies/terms-and-conditions",
    "/post/ulez-explained-by-cinch",
    "/returns",
    "/sign-up",
    "/terms-and-conditions",
    "/which-car-should-i-buy"
  ],
  inAppBrowserHosts: [
    "trial.bonafidee.com",
    "secure.bonafidee.com",
    "web.evolutionfunding.com",
    "www.evolutionfunding.com",
    "evolutionfunding.com",
    "sandbox.evolutionfunding.com",
    "public.evolutionfunding.com",
    "www.blackhorse.co.uk",
    "www.google.com",
    "google.com",
    "bonafidee.com",
    "uk.trustpilot.com",
    "www.gov.uk",
    "gov.uk",
    "assets-dev.cinch.co.uk",
    "assets-production.cinch.co.uk",
    "www.ramplimited.co.uk",
    "cinch.tempcover.com",
    "www.cinch.tempcover.com",
    "www.experian.co.uk",
    "www.transunion.co.uk",
    "equifax.co.uk",
    "www.equifax.co.uk"
  ],
  inAppBrowserPaths: [
    "/privacy",
    "/terms-of-use",
    "/policies/privacy",
    "/support",
    "/car-inspection",
    "/news/ulez-explained-by-cinch",
    "/car-care/cinch-shield",
    "/car-care/charging-electric-cars",
    "/car-care/electric-car-home-charger",
    "/policies/terms-and-conditions"
  ],
  outsideAppBrowserURLs: ["wa.me", "api.whatsapp.com"],
  webviewThirdPartyURLs: ["stripe.com", "pm-redirects.stripe.com", "tink.com"],
  nativeScreenURLs: [
    "/",
    "/my-profile",
    "/my-profile/favourites",
    "/native-favourites",
    "/native-home",
    "/native-my-profile",
    "/native-part-exchange"
  ],
  mainWebviewTitles: {
    Search: "Find a car",
    ProductPage: "Car details",
    OrderOverview: "Order overview",
    CreateAccount: "Create an account",
    PersonalDetails: "Enter your details",
    WantToPartExchange: "Add a part exchange",
    HowDoYouWantToPay: "Choose a payment option",
    FinanceCalculator: "Finance calculator",
    YourDetails: "Enter your details",
    AddAddressHistory: "Add address history",
    AddWorkHistory: "Add work history",
    CompareCars: "Compare cars",
    IncomingsAndOutgoings: "Incomings and outgoings",
    BankAccountMatch: "Bank account match",
    CheckAndSubmit: "Check and submit",
    UploadYourSettlementLetter: "Upload your settlement letter",
    AllFinancePagesPostOffer: "Finance application submitted",
    ChooseADelivery: "Pick a time slot",
    CarCare: "Add car care",
    ReviewAndPay: "Review and pay",
    OrderConfirmation: "Order confirmation",
    OrderBankPayment: "Bank Payment",
    CancelOrder: "Cancel your order",
    IDVerification: "ID Verification",
    EditCustomerInformation: "Edit customer information",
    CheckEligibility: "Finance eligibility checker",
    CarFinance: "Car finance",
    HelpMeChoose: "Help me choose",
    CanNotApply: "You can't apply for car finance"
  },
  webviewSheetTitles: {
    SIGNUP: "Sign up",
    TERMS: "Terms of use",
    COOKIE: "Cookie policy",
    PRIVACY: "Privacy policy",
    SUPPORT: "Support",
    PASSWORD: "Change password",
    DELIVERY: "Home delivery",
    PARTEXCHANGE: "Part exchange",
    RETURNS: "Returns",
    CARFINANCE: "Car finance",
    PCPEXPLANATION: "Personal contract purchase (PCP)",
    HPEXPLANATION: "Hire purchase (HP)",
    ULEZEXPLAINEDBYCINCH: "ULEZ explained by Cinch",
    WARRANTYINFORMATION: "Warranty inclusions and exclusions",
    SERVICING: "Routine servicing",
    TERMSOFUSE: "Terms of use",
    SUPPORTWEBVIEW: "Support",
    PRIVACYCOOKIE: "Privacy & cookie policy",
    CINCHIDD: "Initial Disclosure Document",
    CINCHSHIELD: "Cinch Shield",
    CINCHSHIELDLIFESHINE: "Lifeshine guarantee - Terms and conditions",
    CINCHCARE: "Cinch Care",
    TERMSCOND: "Car purchase terms and conditions",
    DEFAULT: "",
    Whatsapp: "Whatsapp",
    CHECKELIGIBILITY: "Check eligibility",
    CINCHCHARGE: "cinchCharge",
    CARINSPECTION: "Car inspection",
    COLLECTIONS: "Car collections",
    COLLECTIONLOCATION: "Collection location"
  },
  saleConfig: {
    TEXT: "Black Friday Buzz - ",
    SHOW_LINK: true,
    LINK_TEXT: "Shop EVs on offer \u2794",
    LINK_TAG: "Cars-on-offer",
    TEXT_COLOR: "pureWhite",
    BACKGROUND_COLOR: "pureBlack",
    TC_TEXT: "Ends 12pm 28/11. Discount varies by car. Charging valid only at cinchCharge network locations. ",
    TC_LINK_TEXT: "T&Cs apply.",
    TC_URL: "https://mobile.snc-prod.aws.cinch.co.uk/offers"
  }
};

// src/features/index.ts
var AppFeatures = [
  "showAdminFee",
  "yourOrdersMyProfile",
  "hideHomeVehicleCardDetails",
  "pushNotificationOptIn",
  "saleBanner",
  "marketingOutboundCalling"
];

// src/post-messages/schemas.ts
var import_zod = require("zod");
var FavouritesPostMessageSchema = import_zod.z.object({
  make: import_zod.z.string(),
  model: import_zod.z.string(),
  modelYear: import_zod.z.number(),
  vehicleId: import_zod.z.string()
});
var SearchFiltersAppliedSchema = import_zod.z.object({
  searchResultsCount: import_zod.z.number(),
  searchParameters: import_zod.z.object({
    bodyType: import_zod.z.string(),
    colour: import_zod.z.string(),
    seats: import_zod.z.string(),
    doors: import_zod.z.string(),
    fromEngineSize: import_zod.z.number(),
    toEngineSize: import_zod.z.number(),
    fuelType: import_zod.z.string(),
    make: import_zod.z.string(),
    selectedModel: import_zod.z.string(),
    variant: import_zod.z.string(),
    mileage: import_zod.z.number(),
    fromPrice: import_zod.z.number(),
    toPrice: import_zod.z.number(),
    transmissionType: import_zod.z.string(),
    fromYear: import_zod.z.number(),
    toYear: import_zod.z.number(),
    sortingCriteria: import_zod.z.number(),
    pageSize: import_zod.z.number(),
    pageNumber: import_zod.z.number(),
    useMonthly: import_zod.z.boolean(),
    driveType: import_zod.z.string(),
    priceField: import_zod.z.enum(["subsPrice6", "subsPrice12", "subsPrice18", "subsPrice24"]),
    tags: import_zod.z.string(),
    features: import_zod.z.string()
  }).partial()
});
var CheckoutStepVisitedPostMessageSchema = import_zod.z.object({
  orderId: import_zod.z.string(),
  vehicleId: import_zod.z.string(),
  step: import_zod.z.string()
});
var AppReturnHomePostMessageSchema = import_zod.z.object({
  isReturnHome: import_zod.z.boolean()
});
var YourOrderUserUnauthenticatedSchema = import_zod.z.string();
var AppWebviewTitleSchema = import_zod.z.string();
var ShowMainWebViewBorderSchema = import_zod.z.object({
  showBorder: import_zod.z.boolean()
});
var PdpVehicleIdSchema = import_zod.z.string();
var schemas = {
  appReturnHome: AppReturnHomePostMessageSchema,
  appWebviewTitle: AppWebviewTitleSchema,
  checkoutStepVisited: CheckoutStepVisitedPostMessageSchema,
  favouriteVehicleAdded: FavouritesPostMessageSchema,
  favouriteVehicleRemoved: FavouritesPostMessageSchema,
  pdpVehicleId: PdpVehicleIdSchema,
  searchFiltersApplied: SearchFiltersAppliedSchema,
  showMainWebViewBorder: ShowMainWebViewBorderSchema,
  yourOrderUserUnauthenticated: YourOrderUserUnauthenticatedSchema
};

// src/post-messages/sendPostMessage.ts
function sendPostMessage(type, ...rest) {
  if (typeof window === "undefined" || typeof window.ReactNativeWebView === "undefined") {
    return;
  }
  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      type,
      ...Boolean(rest[0]) && { data: rest[0] }
    })
  );
}

// src/post-messages/createPostMessageHandlers.ts
var isValidPostMessageType = (handlers, messageType) => {
  return typeof messageType === "string" && Object.keys(handlers).includes(messageType);
};
var createPostMessageHandlers = (handlers, onError) => {
  return (msg) => {
    try {
      const parsedMessage = JSON.parse(msg);
      if (!Object.prototype.hasOwnProperty.call(parsedMessage, "type")) {
        onError(msg);
        return;
      }
      const messageType = parsedMessage.type;
      if (!isValidPostMessageType(handlers, messageType)) {
        onError(msg);
        return;
      }
      schemas[messageType].parse(parsedMessage.data);
      handlers[messageType](parsedMessage.data);
    } catch {
      onError(msg);
    }
  };
};

// src/env/dev/webviewTitles.ts
var { webviewSheetURLs, mainWebviewLoggedInURLs, mainWebviewLoggedOutURLs } = app_config_default;
var devMainWebviewTitlesRecord = {
  "/car-finance/check-eligibility": "CheckEligibility",
  "/checkout/bank-payment/": "OrderBankPayment",
  "/checkout/car-care/": "CarCare",
  "/checkout/card-details/": "ReviewAndPay",
  "/checkout/confirmation/": "OrderConfirmation",
  "/checkout/delivery/": "ChooseADelivery",
  "/checkout/editable-customer-info/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-approved/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-decision/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-offer/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-outgoings/": "IncomingsAndOutgoings",
  "/checkout/finance-application-review/": "AllFinancePagesPostOffer",
  "/checkout/finance-bank-details/": "BankAccountMatch",
  "/checkout/finance-cant-apply/": "CanNotApply",
  "/checkout/finance-current-address/": "AddAddressHistory",
  "/checkout/finance-employment-history/": "AddWorkHistory",
  "/checkout/finance-offer-amends/": "AllFinancePagesPostOffer",
  "/checkout/finance-personal-details/": "YourDetails",
  "/checkout/finance/": "FinanceCalculator",
  "/checkout/part-exchange": "WantToPartExchange",
  "/checkout/payment/": "HowDoYouWantToPay",
  "/checkout/personal-details/": "PersonalDetails",
  "/checkout/settlement-letter-upload/": "UploadYourSettlementLetter",
  "/checkout/your-order/": "OrderOverview",
  "/compare-cars": "CompareCars",
  "/find-vehicle": "Search",
  "/help-me-choose/body-types": "HelpMeChoose",
  "/help-me-choose/car-makes": "HelpMeChoose",
  "/help-me-choose/most-important": "HelpMeChoose",
  "/help-me-choose/passengers": "HelpMeChoose",
  "/help-me-choose/price-range": "HelpMeChoose",
  "/help-me-choose/recommendations": "HelpMeChoose",
  "/part-exchange/calculator": "WantToPartExchange",
  "/used-cars/": "ProductPage",
  "/used-cars": "Search"
};
var devWebviewSheetTitlesRecord = {
  "/car-care/charging-electric-cars": "CINCHCHARGE",
  "/car-collections": "COLLECTIONS",
  "/car-finance": "CARFINANCE",
  "/cars-near-me/collection-location": "COLLECTIONLOCATION",
  "/cinch-care": "CINCHCARE",
  "/cinch-care/servicing": "SERVICING",
  "/cinch-care/warranty-information": "WARRANTYINFORMATION",
  "/cinch-shield": "CINCHSHIELD",
  "/cinchshield-lifeshine-guarantee": "CINCHSHIELDLIFESHINE",
  "/delivery": "DELIVERY",
  "/finance/Cinch_IDD": "CINCHIDD",
  "/finance/hp-explanation": "HPEXPLANATION",
  "/finance/pcp-explanation": "PCPEXPLANATION",
  "/news/ulez-explained-by-cinch": "ULEZEXPLAINEDBYCINCH",
  "/part-exchange": "PARTEXCHANGE",
  "/policies/terms-and-conditions": "TERMSCOND",
  "/post/ulez-explained-by-cinch": "ULEZEXPLAINEDBYCINCH",
  "/returns": "RETURNS",
  "/sign-up": "SIGNUP",
  "/terms-and-conditions": "TERMSCOND"
};
var getDevMainWebviewTitle = (url, config) => {
  if (url === "/") return "";
  const pathname = [...mainWebviewLoggedInURLs, ...mainWebviewLoggedOutURLs].find((path) => url.includes(path));
  if (!pathname) {
    throw new Error(`Url: "${url}" is invalid`);
  }
  const titleKey = devMainWebviewTitlesRecord[pathname];
  if (!titleKey) {
    throw new Error(`No title found for pathname: ${pathname}`);
  }
  return config[titleKey];
};
var getDevWebviewSheetTitle = (url, config) => {
  if (url === "/") return "";
  const pathname = webviewSheetURLs.find((path) => url.includes(path));
  if (!pathname) {
    throw new Error(`Url: "${url}" is invalid`);
  }
  const titleKey = devWebviewSheetTitlesRecord[pathname];
  if (!titleKey) {
    throw new Error(`No title found for pathname: ${pathname}`);
  }
  return config[titleKey];
};

// src/env/prod/webviewTitles.ts
var { webviewSheetURLs: webviewSheetURLs2, mainWebviewLoggedInURLs: mainWebviewLoggedInURLs2, mainWebviewLoggedOutURLs: mainWebviewLoggedOutURLs2 } = app_config_default2;
var prodMainWebviewTitlesRecord = {
  "/car-finance/check-eligibility": "CheckEligibility",
  "/checkout/bank-payment/": "OrderBankPayment",
  "/checkout/car-care/": "CarCare",
  "/checkout/card-details/": "ReviewAndPay",
  "/checkout/confirmation/": "OrderConfirmation",
  "/checkout/delivery/": "ChooseADelivery",
  "/checkout/editable-customer-info/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-approved/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-decision/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-offer/": "AllFinancePagesPostOffer",
  "/checkout/finance-application-outgoings/": "IncomingsAndOutgoings",
  "/checkout/finance-application-review/": "AllFinancePagesPostOffer",
  "/checkout/finance-bank-details/": "BankAccountMatch",
  "/checkout/finance-cant-apply/": "CanNotApply",
  "/checkout/finance-current-address/": "AddAddressHistory",
  "/checkout/finance-employment-history/": "AddWorkHistory",
  "/checkout/finance-offer-amends/": "AllFinancePagesPostOffer",
  "/checkout/finance-personal-details/": "YourDetails",
  "/checkout/finance/": "FinanceCalculator",
  "/checkout/part-exchange": "WantToPartExchange",
  "/checkout/payment/": "HowDoYouWantToPay",
  "/checkout/personal-details/": "PersonalDetails",
  "/checkout/settlement-letter-upload/": "UploadYourSettlementLetter",
  "/checkout/your-order/": "OrderOverview",
  "/compare-cars": "CompareCars",
  "/find-vehicle": "Search",
  "/help-me-choose/body-types": "HelpMeChoose",
  "/help-me-choose/car-makes": "HelpMeChoose",
  "/help-me-choose/most-important": "HelpMeChoose",
  "/help-me-choose/passengers": "HelpMeChoose",
  "/help-me-choose/price-range": "HelpMeChoose",
  "/help-me-choose/recommendations": "HelpMeChoose",
  "/part-exchange/calculator": "WantToPartExchange",
  "/used-cars/": "ProductPage",
  "/used-cars": "Search"
};
var prodWebviewSheetTitlesRecord = {
  "/car-care/charging-electric-cars": "CINCHCHARGE",
  "/car-collections": "COLLECTIONS",
  "/car-finance": "CARFINANCE",
  "/cars-near-me/collection-location": "COLLECTIONLOCATION",
  "/cinch-care": "CINCHCARE",
  "/cinch-care/servicing": "SERVICING",
  "/cinch-care/warranty-information": "WARRANTYINFORMATION",
  "/cinch-shield": "CINCHSHIELD",
  "/cinchshield-lifeshine-guarantee": "CINCHSHIELDLIFESHINE",
  "/delivery": "DELIVERY",
  "/finance/Cinch_IDD": "CINCHIDD",
  "/finance/hp-explanation": "HPEXPLANATION",
  "/finance/pcp-explanation": "PCPEXPLANATION",
  "/news/ulez-explained-by-cinch": "ULEZEXPLAINEDBYCINCH",
  "/part-exchange": "PARTEXCHANGE",
  "/policies/terms-and-conditions": "TERMSCOND",
  "/post/ulez-explained-by-cinch": "ULEZEXPLAINEDBYCINCH",
  "/returns": "RETURNS",
  "/sign-up": "SIGNUP",
  "/terms-and-conditions": "TERMSCOND"
};
var getProdMainWebviewTitle = (url, config) => {
  if (url === "/") return "";
  const pathname = [...mainWebviewLoggedInURLs2, ...mainWebviewLoggedOutURLs2].find((path) => url.includes(path));
  if (!pathname) {
    throw new Error(`Url: "${url}" is invalid`);
  }
  const titleKey = prodMainWebviewTitlesRecord[pathname];
  if (!titleKey) {
    throw new Error(`No title found for pathname: ${pathname}`);
  }
  return config[titleKey];
};
var getProdWebviewSheetTitle = (url, config) => {
  if (url === "/") return "";
  const pathname = webviewSheetURLs2.find((path) => url.includes(path));
  if (!pathname) {
    throw new Error(`Url: "${url}" is invalid`);
  }
  const titleKey = prodWebviewSheetTitlesRecord[pathname];
  if (!titleKey) {
    throw new Error(`No title found for pathname: ${pathname}`);
  }
  return config[titleKey];
};

// src/env/types.ts
var import_zod2 = require("zod");
var zMainWebviewTitles = import_zod2.z.object({
  Search: import_zod2.z.string(),
  ProductPage: import_zod2.z.string(),
  OrderOverview: import_zod2.z.string(),
  CreateAccount: import_zod2.z.string(),
  PersonalDetails: import_zod2.z.string(),
  WantToPartExchange: import_zod2.z.string(),
  HowDoYouWantToPay: import_zod2.z.string(),
  FinanceCalculator: import_zod2.z.string(),
  YourDetails: import_zod2.z.string(),
  AddAddressHistory: import_zod2.z.string(),
  AddWorkHistory: import_zod2.z.string(),
  CompareCars: import_zod2.z.string(),
  IncomingsAndOutgoings: import_zod2.z.string(),
  BankAccountMatch: import_zod2.z.string(),
  CheckAndSubmit: import_zod2.z.string(),
  UploadYourSettlementLetter: import_zod2.z.string(),
  AllFinancePagesPostOffer: import_zod2.z.string(),
  ChooseADelivery: import_zod2.z.string(),
  CarCare: import_zod2.z.string(),
  ReviewAndPay: import_zod2.z.string(),
  OrderConfirmation: import_zod2.z.string(),
  OrderBankPayment: import_zod2.z.string(),
  CancelOrder: import_zod2.z.string(),
  IDVerification: import_zod2.z.string(),
  EditCustomerInformation: import_zod2.z.string(),
  CheckEligibility: import_zod2.z.string(),
  CarFinance: import_zod2.z.string(),
  HelpMeChoose: import_zod2.z.string(),
  CanNotApply: import_zod2.z.string()
});
var zWebviewSheetTitles = import_zod2.z.object({
  SIGNUP: import_zod2.z.string(),
  TERMS: import_zod2.z.string(),
  COOKIE: import_zod2.z.string(),
  PRIVACY: import_zod2.z.string(),
  SUPPORT: import_zod2.z.string(),
  PASSWORD: import_zod2.z.string(),
  DELIVERY: import_zod2.z.string(),
  PARTEXCHANGE: import_zod2.z.string(),
  RETURNS: import_zod2.z.string(),
  CARFINANCE: import_zod2.z.string(),
  PCPEXPLANATION: import_zod2.z.string(),
  HPEXPLANATION: import_zod2.z.string(),
  ULEZEXPLAINEDBYCINCH: import_zod2.z.string(),
  WARRANTYINFORMATION: import_zod2.z.string(),
  SERVICING: import_zod2.z.string(),
  TERMSOFUSE: import_zod2.z.string(),
  SUPPORTWEBVIEW: import_zod2.z.string(),
  PRIVACYCOOKIE: import_zod2.z.string(),
  CINCHIDD: import_zod2.z.string(),
  CINCHSHIELD: import_zod2.z.string(),
  CINCHSHIELDLIFESHINE: import_zod2.z.string(),
  CINCHCARE: import_zod2.z.string(),
  TERMSCOND: import_zod2.z.string(),
  DEFAULT: import_zod2.z.string(),
  Whatsapp: import_zod2.z.string(),
  CHECKELIGIBILITY: import_zod2.z.string(),
  CINCHCHARGE: import_zod2.z.string(),
  CARINSPECTION: import_zod2.z.string(),
  COLLECTIONS: import_zod2.z.string(),
  COLLECTIONLOCATION: import_zod2.z.string()
});
var zSaleConfig = import_zod2.z.object({
  TEXT: import_zod2.z.string(),
  SHOW_LINK: import_zod2.z.boolean(),
  LINK_TEXT: import_zod2.z.string(),
  LINK_TAG: import_zod2.z.string(),
  TEXT_COLOR: import_zod2.z.string(),
  BACKGROUND_COLOR: import_zod2.z.string(),
  TC_TEXT: import_zod2.z.string(),
  TC_LINK_TEXT: import_zod2.z.string(),
  TC_URL: import_zod2.z.string()
});
var zMainWebviewTitleKeys = zMainWebviewTitles.keyof();
var zWebviewSheetTitleKeys = zWebviewSheetTitles.keyof();
var zDynamicConfigBase = import_zod2.z.object({
  aprValue: import_zod2.z.string(),
  mainWebviewLoggedInURLs: import_zod2.z.array(import_zod2.z.string()),
  mainWebviewLoggedOutURLs: import_zod2.z.array(import_zod2.z.string()),
  webviewSheetURLs: import_zod2.z.array(import_zod2.z.string()),
  inAppBrowserHosts: import_zod2.z.array(import_zod2.z.string()),
  inAppBrowserPaths: import_zod2.z.array(import_zod2.z.string()),
  outsideAppBrowserURLs: import_zod2.z.array(import_zod2.z.string()),
  webviewThirdPartyURLs: import_zod2.z.array(import_zod2.z.string()),
  nativeScreenURLs: import_zod2.z.array(import_zod2.z.string()),
  mainWebviewTitles: zMainWebviewTitles,
  webviewSheetTitles: zWebviewSheetTitles,
  saleConfig: zSaleConfig
});
var zPlatformConfig = import_zod2.z.object({
  requiredAppVersion: import_zod2.z.string(),
  recommendedAppVersion: import_zod2.z.string().optional(),
  isSuspended: import_zod2.z.boolean().default(false)
});
var zDynamicConfig = zDynamicConfigBase.merge(
  import_zod2.z.object({
    ios: zPlatformConfig,
    android: zPlatformConfig
  })
).passthrough();
var zFlatConfig = zDynamicConfigBase.merge(zPlatformConfig);
var devConfig = zDynamicConfig.parse(app_config_default);
var prodConfig = zDynamicConfig.parse(app_config_default2);

// npm-package/index.ts
var devAppConfig = app_config_default;
var prodAppConfig = app_config_default2;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AppFeatures,
  createPostMessageHandlers,
  devAppConfig,
  devConfig,
  devMainWebviewTitlesRecord,
  devWebviewSheetTitlesRecord,
  getDevMainWebviewTitle,
  getDevWebviewSheetTitle,
  getProdMainWebviewTitle,
  getProdWebviewSheetTitle,
  prodAppConfig,
  prodConfig,
  prodMainWebviewTitlesRecord,
  prodWebviewSheetTitlesRecord,
  schemas,
  sendPostMessage,
  zDynamicConfig,
  zMainWebviewTitleKeys,
  zMainWebviewTitles,
  zSaleConfig,
  zWebviewSheetTitleKeys,
  zWebviewSheetTitles
});
